<template>
     <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="mode =='I'" >New Insert Mode </p>
                <p class="modal-card-title " v-if="mode =='U'" >Edit Mode</p>
                <button class="delete" aria-label="close" @click="closeBtn"></button>
            </header>
            <section class="modal-card-body">
                <b-field label="Drug Name">
                    <b-input v-model="dataDrugToEdit.name" >{{dataDrugToEdit.name}}</b-input>
                </b-field>
                <b-field label="Status">
                    <b-switch  type="is-success" v-model=" dataDrugToEdit.enable "></b-switch>
                </b-field>

            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>
                <b-button type="is-success"  @click="UpdateDrugs">Update</b-button>
            </footer>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import {  getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
import {mapState} from "vuex";

export default {
    name : 'EditDrugParasite',
    props:{
            dataDrugToEdit : Object,
            mode : String // 'I' === insert , 'U' === Update
    },
    computed: {
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
    },
    methods:{
            closeBtn(){
                this.$emit('close')
            },
            UpdateDrugs(){
                var datTo = {}
                var endPoint = ''
                if(this.mode == 'I'){
                    datTo =    {
                                    "name":   this.dataDrugToEdit.name,
                                    "enable": this.dataDrugToEdit.enable
                                }
                    endPoint = 'addnew_drugs_parasite'
                }else if(this.mode == 'U'){
                    datTo =    {
                                    "id":     this.dataDrugToEdit.id,
                                    "name":   this.dataDrugToEdit.name,
                                    "enable": this.dataDrugToEdit.enable
                                }
                    endPoint = 'update_drugs_parasite'
                }



                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`, datTo, getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$emit('closeWithDataChange')
                        }
                        vm.isFullScreenSearching = false
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        vm.isFullScreenSearching = false
                    })





            }
    },
    data(){
            return {
                isFullScreenSearching : false
            }
    }
}
</script>